import React, { useEffect, useState } from "react";
import LabelInput from '../../../Component/labelInput';
import PageTitle from '../../../module/pageTitle';
import { InputField, Submitbtn } from '../../../Component';
import DropDown from '../../../Component/dropdown';
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getDepartmentList, addSubDepartment } from "../superAdminSlice";
import { validateIsLettersAndDigitsSpaceOnly } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const AddSubDepartment = () => {
    const dispatch: Function = useDispatch<AppDispatch>();
    const [departmentList, setDepartmentList] = useState<any>([]);
    const [department, setDepartment] = useState<any>("");
    const [subDepartment, setSubDepartment] = useState<any>("");
    useEffect(() => {
        dispatch(
            getDepartmentList({
                callback: (res: any) => {
                    setDepartmentList(res?.data);
                    dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
                errorCallback: () => {
                    dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
            })
        );
    }, []);

    const validations = () => {
        return department === "" ||
            subDepartment === ""
    };
    const onChangeDepartment = (val: any) => {
        setDepartment(val)
    }
    const onChangeSubDepartment = (value: string) => {
        if (validateIsLettersAndDigitsSpaceOnly(value)) {
            setSubDepartment(value);
        }

    };
    const handleSubmit = (e: { preventDefault: () => void }) => {
        e.preventDefault();
        const postData = {
            departmentId: department?._id,
            name: subDepartment

        };
        dispatch(
            addSubDepartment({
                params: postData,
                callback: (res: any) => {
                    dispatch(showSnackbar({ message: "Subdepartment added Successfully", type: res?.data?.status }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);

                },
                errorCallback: (error: any) => {
                    dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }))
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
            })
        );
        setSubDepartment("");
        setDepartment("");
    }
    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Add Sub Department"}
                    breadCrumb={''}
                    isEditMode={''}
                    cancelEdit={() => ('')} />
            </div>
            <div className='formDiv'>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    <form onSubmit={handleSubmit}>
                        <div className='row align-items-center'>
                            <div className='col-md-4'>
                                <LabelInput labelName={"Department"} />
                                <DropDown
                                    labelName={"Select Department"}
                                    setInputText={(value: any) => onChangeDepartment(value)}
                                    options={departmentList}
                                    value={department}
                                />
                            </div>
                            <div className='col-md-4'>
                                <LabelInput labelName={"Sub Department"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Sub Department Name"}
                                    value={subDepartment}
                                    setInputText={(value: any) => onChangeSubDepartment(value)}
                                />
                            </div>
                            <div className='col-md-2'>
                                <LabelInput labelName={""} />
                                <Submitbtn name={"Add"} disabled={validations()} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default AddSubDepartment;